import { useEffect, useState } from "react";

const AUTH_STATUS_KEY = "crayo_auth_status";
const AUTH_CHECK_KEY = "crayo_auth_checked";

export const useAuthStatus = () => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const checkAuthStatus = async () => {
      const hasChecked = sessionStorage.getItem(AUTH_CHECK_KEY);
      const cachedStatus = sessionStorage.getItem(AUTH_STATUS_KEY);

      if (hasChecked && cachedStatus !== null) {
        setIsAuthenticated(cachedStatus === "true");
        setIsLoading(false);
        return;
      }

      try {
        const response = await fetch("https://crayo.ai/api/auth/is-authed", {
          method: "GET",
          credentials: "include",
        });

        if (!response.ok) {
          throw new Error("Auth check failed");
        }

        const data = await response.json();
        const isAuthed = data.isAuthed;

        sessionStorage.setItem(AUTH_CHECK_KEY, "true");
        sessionStorage.setItem(AUTH_STATUS_KEY, String(isAuthed));

        setIsAuthenticated(isAuthed);
      } catch (error) {
        console.error("Error checking auth status:", error);
        setIsAuthenticated(false);
      } finally {
        setIsLoading(false);
      }
    };

    checkAuthStatus();
  }, []);

  return { isAuthenticated, isLoading };
};
